var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeDecor1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 785.87 684.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:#ffdd40;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 939.25,
    y1: 253.69,
    x2: 83.08,
    y2: 253.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fcd846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f3cb58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e5b576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d0979e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#b770d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 466.27,
    y1: 132.98,
    x2: 205.04,
    y2: 132.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f8d24f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d8a38f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c180bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b36bd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 441.43,
    y1: 132.98,
    x2: -38.58,
    y2: 132.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f0c65f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d8a38e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c687b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b973ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b167de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 753.02,
    y1: 325.99,
    x2: 605.16,
    y2: 325.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fedb42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fad54a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f3cb58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#eabd6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ddaa85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ce93a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bc78c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 858.29,
    y1: 155.66,
    x2: 270.91,
    y2: 155.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fcd946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f4cd55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e7ba70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d59e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be7cc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 597.56,
    y1: 93.98,
    x2: 212.25,
    y2: 93.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ecc067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cb8eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#b66fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 502.92,
    y1: 92.98,
    x2: -11.37,
    y2: 92.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e9bd6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d0969f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#be7ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b269dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 207.61,
    y1: 92.98,
    x2: 84.09,
    y2: 92.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#e8ba6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d69f93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c789b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#bc78c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b46cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#af65e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 189.2,
    y1: 92.98,
    x2: -32.84,
    y2: 92.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fdda44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#e8bb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d6a092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c88ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bc79c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b46cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#af65e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 821.89,
    y1: 290.18,
    x2: 608.06,
    y2: 290.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fedb42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fad54a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f3cb58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#eabd6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#deab84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ce94a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#bd79c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 941.34,
    y1: 104.48,
    x2: 168.12,
    y2: 104.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fcd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f5ce54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e9bc6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d8a38e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c383b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 659.32,
    y1: 49.98,
    x2: -55.79,
    y2: 49.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2ca5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#daa58b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c789b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b974cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b167de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 308.18,
    y1: 49.98,
    x2: -51.01,
    y2: 49.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fbd749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e6b872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d59e95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c788b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#bc78c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#b46cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#af65e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 137.16,
    y1: 49.66,
    x2: -81.62,
    y2: 50.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fddb43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ebbf69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#dba68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#cd91a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c180bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b973ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b36adb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#af65e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 815.32,
    y1: 327.02,
    x2: 722.08,
    y2: 327.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fedb42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fad54b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f3cb59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e9bc6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#dca986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cd91a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ba75cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 802.93,
    y1: 226.29,
    x2: 700.62,
    y2: 226.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fedb42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fad54b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f3ca59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e9bb6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#dca887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cc90a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ba75cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 778.37,
    y1: 166.95,
    x2: 676.89,
    y2: 166.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fdda43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f8d24e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#efc560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e3b279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d39a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bf7dc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 867.01,
    y1: 82.19,
    x2: 394.11,
    y2: 82.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fcd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f5ce55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e8bb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d7a092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c07fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 817.16,
    y1: 17.9,
    x2: 4.2,
    y2: 17.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 362.7,
    y1: 10.23,
    x2: 146.04,
    y2: 10.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#edc265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d7a092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c586b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b873cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b167df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 366.78,
    y1: 10.42,
    x2: -111.4,
    y2: 10.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#eec462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#dba689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#cb8eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#be7bc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b56ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b066e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae63e4"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.51,389.39h-.45A15,15,0,0,1,634.51,374c2.22-76.22-14.91-133.66-50.91-170.72C548,166.57,492.11,148,417.5,148a15,15,0,0,1,0-30c83,0,146.15,21.65,187.62,64.35C647,225.43,667,290.19,664.49,374.82A15,15,0,0,1,649.51,389.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.5,148h-50a15,15,0,0,1,0-30h50a15,15,0,1,1,0,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.5,148h-117a15,15,0,0,1,0-30h117a15,15,0,1,1,0,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M693.1,419.89a12.5,12.5,0,0,1-12.5-12.5c0-80.37-6.57-122.65-19.53-158.54a12.5,12.5,0,1,1,23.51-8.49c13.95,38.61,21,85.63,21,167A12.5,12.5,0,0,1,693.1,419.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M657.44,222.66a12.51,12.51,0,0,1-11-6.52,192,192,0,0,0-62-68.56c-23.59-15.83-52-27.33-84.47-34.19a12.5,12.5,0,0,1,5.18-24.46c75.38,15.94,130.31,54.71,163.27,115.25a12.51,12.51,0,0,1-11,18.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M461.52,107.48c-.4,0-.8,0-1.2,0-13.58-1.29-28-2-42.82-2h-49a12.5,12.5,0,0,1,0-25h49c15.62,0,30.83.7,45.18,2.06a12.5,12.5,0,0,1-1.16,24.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M325.5,105.48H193a12.5,12.5,0,0,1,0-25H325.5a12.5,12.5,0,0,1,0,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M155.5,105.48H142.67a12.5,12.5,0,0,1,0-25H155.5a12.5,12.5,0,0,1,0,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M105.5,105.48h-43a12.5,12.5,0,0,1,0-25h43a12.5,12.5,0,0,1,0,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M735.82,389.89a17.51,17.51,0,0,1-17.5-17.5c0-60.49-9.76-113.45-29-157.4a17.5,17.5,0,1,1,32.06-14c21.2,48.41,32,106.09,32,171.44A17.5,17.5,0,0,1,735.82,389.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M675.9,174.07a17.47,17.47,0,0,1-14.11-7.13c-41.14-55.87-104.88-88.55-189.46-97.13A17.5,17.5,0,1,1,475.86,35C570.69,44.6,642.73,82,690,146.19a17.51,17.51,0,0,1-14.08,27.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M412.5,67.48h-184a17.5,17.5,0,1,1,0-35h184a17.5,17.5,0,0,1,0,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M175.5,67.48h-75a17.5,17.5,0,1,1,0-35h75a17.5,17.5,0,0,1,0,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M49.5,67.48h-32a17.5,17.5,0,0,1,0-35h32a17.5,17.5,0,0,1,0,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M775.42,388.39a10,10,0,0,1-10-10c0-36.13-2.82-70.1-8.39-101a10,10,0,0,1,19.68-3.55c5.78,32,8.71,67.19,8.71,104.51A10,10,0,0,1,775.42,388.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M760.12,254.61a10,10,0,0,1-9.69-7.52,372.75,372.75,0,0,0-11-35.68,10,10,0,1,1,18.77-6.88c4.39,12,8.3,24.62,11.63,37.59a10,10,0,0,1-7.21,12.17A9.65,9.65,0,0,1,760.12,254.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M735.83,187.34a10,10,0,0,1-9-5.64c-3.34-6.88-6.94-13.64-10.71-20.08a10,10,0,0,1,17.26-10.1c4,6.89,7.88,14.11,11.44,21.45a10,10,0,0,1-9,14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M705.37,137.64a10,10,0,0,1-8-3.92C667.37,94.45,626.86,65,577,46.1a10,10,0,0,1,7.08-18.7c53.4,20.2,96.87,51.89,129.23,94.16a10,10,0,0,1-7.94,16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M546.47,35.8a10.24,10.24,0,0,1-2.61-.35C505.74,25.2,462.22,20,414.5,20c-33.72,0-67.95.06-97,.12h0a10,10,0,0,1,0-20c29-.06,63.28-.12,97-.12C464,0,509.24,5.43,549.06,16.14a10,10,0,0,1-2.59,19.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M236.87,20.29a10,10,0,0,1,0-20L261.66.23,283.2.18h0a10,10,0,0,1,0,20l-21.53.05-24.82.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M77,20.48a10,10,0,0,1,0-20c39.83,0,80,0,126.42-.12h0a10,10,0,0,1,0,20C157,20.45,116.84,20.48,77,20.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M736,488.36a17.5,17.5,0,0,1-17.5-17.5V420.77a17.5,17.5,0,0,1,35,0v50.09A17.51,17.51,0,0,1,736,488.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M693.39,585.63a12.5,12.5,0,0,1-12.5-12.5V445.75a12.5,12.5,0,1,1,25,0V573.13A12.5,12.5,0,0,1,693.39,585.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M693.39,641.73a12.5,12.5,0,0,1-12.5-12.5V613.29a12.5,12.5,0,0,1,25,0v15.94A12.5,12.5,0,0,1,693.39,641.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M736,684.27a17.49,17.49,0,0,1-17.5-17.5V519a17.5,17.5,0,0,1,35,0V666.77A17.5,17.5,0,0,1,736,684.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M775.87,440.2a10,10,0,0,1-10-10V414.26a10,10,0,0,1,20,0V430.2A10,10,0,0,1,775.87,440.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M775.87,551.35a10,10,0,0,1-10-10V465.18a10,10,0,1,1,20,0v76.17A10,10,0,0,1,775.87,551.35Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDecor1);
export default __webpack_public_path__ + "static/media/homeDecor1.0de093f75c52d107270e3d29f54e9eb4.svg";
export { ForwardRef as ReactComponent };